import React from 'react';
import { motion } from 'framer-motion';
import { FaHandshake, FaChartLine, FaUsers, FaArrowRight } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const BrokerSection = () => {
  return (
    <section className="py-24 bg-gradient-to-br from-gray-900 to-gray-800 text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10" style={{ backgroundImage: 'radial-gradient(#ffffff 1px, transparent 1px)', backgroundSize: '30px 30px' }}></div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            <span className="text-rose-400 font-bold tracking-wider uppercase text-sm mb-2 block">Partner With Us</span>
            <h2 className="text-4xl lg:text-5xl font-black leading-tight mb-6">
              Become a <span className="text-transparent bg-clip-text bg-gradient-to-r from-rose-400 to-orange-400">Broker Partner</span> & Grow Your Business
            </h2>
            <p className="text-gray-300 text-lg mb-8 leading-relaxed">
              Join India's fastest growing matrimony network. Access our premium database, get dedicated support, and earn attractive commissions on every successful match.
            </p>

            <div className="space-y-6 mb-10">
              {[
                { icon: FaUsers, title: "Access Premium Profiles", desc: "Get exclusive access to verified high-intent profiles." },
                { icon: FaChartLine, title: "High Commission Rates", desc: "Earn up to 40% commission on every premium membership." },
                { icon: FaHandshake, title: "Dedicated Support", desc: "24/7 priority support team to help you close deals faster." }
              ].map((item, index) => (
                <div key={index} className="flex items-start">
                  <div className="w-12 h-12 rounded-xl bg-white/10 flex items-center justify-center text-rose-400 text-xl mr-4 shrink-0">
                    <item.icon />
                  </div>
                  <div>
                    <h4 className="font-bold text-xl mb-1">{item.title}</h4>
                    <p className="text-gray-400 text-sm">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-wrap gap-4">
              <Link to="/broker-register" className="px-8 py-4 bg-rose-600 hover:bg-rose-700 text-white font-bold rounded-xl shadow-lg shadow-rose-600/30 transition-all flex items-center">
                Register as Broker <FaArrowRight className="ml-2" />
              </Link>
              <Link to="/broker-info" className="px-8 py-4 bg-white/10 hover:bg-white/20 text-white font-bold rounded-xl backdrop-blur-sm transition-all">
                Learn More
              </Link>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8 }}
            className="relative"
          >
            <div className="absolute inset-0 bg-gradient-to-r from-rose-500 to-orange-500 rounded-3xl blur-2xl opacity-30 transform rotate-6"></div>
            <img
              src="https://images.unsplash.com/photo-1556761175-5973dc0f32e7?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80"
              alt="Business Meeting"
              className="relative rounded-3xl shadow-2xl border border-white/10 w-full object-cover h-[600px]"
            />

            {/* Floating Stats Card */}
            <div className="absolute -bottom-10 -left-10 bg-white p-6 rounded-2xl shadow-xl max-w-xs hidden md:block">
              <div className="flex items-center gap-4 mb-4">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center text-green-600 text-xl">
                  <FaChartLine />
                </div>
                <div>
                  <p className="text-gray-500 text-xs font-bold uppercase">Monthly Earnings</p>
                  <h4 className="text-2xl font-black text-gray-900">₹ 85,000+</h4>
                </div>
              </div>
              <p className="text-sm text-gray-600">Average earnings of our top performing broker partners.</p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default BrokerSection;